import styled from 'styled-components';

import { CenterFlex, VFlex } from '@/components/base';
import Spinner from '@/components/Common/Spinner';
import Typo from '@/components/Typography/Typo';
import ContactShortItem from '@/features/Contact/ContactShortItem';
import useColor from '@/hooks/domain/useColor';

type Props = {
  customers: CustomerT[];
  hasNextPage: boolean;
  loading: boolean;
  nextClickHandler: () => void;
  onItemClick: (alias: string) => void;
};

const ShortCustomerList = (props: Props) => {
  const color = useColor();

  return (
    <Style>
      <VFlex g={12}>
        <Typo type="body3" color={color.gray700} weight="sb">
          Contacts
        </Typo>
        <VFlex g={4}>
          {props.customers.map((customer) => {
            return (
              <ContactShortItem
                key={customer.alias}
                customer={customer}
                onClick={() => props.onItemClick(customer.alias)}
              />
            );
          })}
          {props.hasNextPage && (
            <CenterFlex style={{ height: 36 }} onClick={props.nextClickHandler}>
              <Typo type="label2" color={color.gray500}>
                Load more
              </Typo>
            </CenterFlex>
          )}
          {props.loading && (
            <CenterFlex style={{ height: 36 }}>
              <Spinner />
            </CenterFlex>
          )}
        </VFlex>
      </VFlex>
    </Style>
  );
};

const Style = styled.div``;

export default ShortCustomerList;
